import React from 'react';

import { Flex, Text } from '@raystack/apsara';

import { useCopilotSelector } from '@src/contexts';
import { Show } from '@src/hoc';
import { PromptsProps } from '@src/utils/types/CopilotTypes';

import styles from './MultiChat.module.css';

export const Prompts = ({ handleSelectPrompt }: PromptsProps) => {
  const promptsData = useCopilotSelector(state => state.prompts);

  return (
    <Show when={promptsData?.sample_prompts?.length !== undefined}>
      <Flex direction='column' gap={5}>
        {promptsData?.sample_prompts?.map((prompt: string, index: number) => (
          <Flex
            key={index}
            className={styles.prompt}
            data-test-id='Prompt'
            onClick={() => handleSelectPrompt(prompt)}
          >
            <Text size='mini' variant='secondary'>
              {prompt}
            </Text>
          </Flex>
        ))}
      </Flex>
    </Show>
  );
};
